/**
 * 共通
 */
 'use strict';
 import '@/_constant/global';
 import pageCommon from '@/_page/pageCommon';
 
 document.addEventListener('DOMContentLoaded', () => {
  gTOCO.mods['page'] = new pageCommon();
 }, false);
 
 window.addEventListener('load', () => {
  gTOCO.mods['page'].start();
 }, false);
 
 window.addEventListener('unload', () => {}, false);
 